// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__BUBF6","container":"Footer_container__fDtjW","column":"Footer_column__+XSxF","logo":"Footer_logo__hRHSU","bottom":"Footer_bottom__ZX0O2"};